import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取主题数据
 * @return {*}
 */
export function GetSubject(id) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/subject/api/GetSubject`,
    method: 'get',
    params: {
      id: id
    }
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}

/**
 * 往期回顾
 * @return {*}
 */
export function History(id) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/subject/api/History`,
    method: 'get',
    params: {
      FromSubjectId: id
    }
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}
